import { ElementChoice } from '../../shared/components/element-choice-select/element-choice'

export class PartySizeChoice implements ElementChoice<number> {

    constructor(
        private size: number
    ) { }

    get id(): string {
        return this.size.toString()
    }

    get displayName(): string {
        if (this.size === 1) {
            return '1 Person'
        }
        return `${this.size} People`
    }

    get value(): number {
        return this.size
    }
}
